export default __webpack_public_path__ + "static/feature10banner-cd0a74455a42eca01c72941628f844f8.svg";